// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewPickerWrapper--VJkkH {
  position: absolute;
}

.cardGrid--ytFdu {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.card--SZjfy {
  flex: 1 1 0;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font: inherit;
  font-size: 15px;
  font-weight: 400;
  color: #000;
  transition: border-color 0.2s ease;
}

[dir] .card--SZjfy {
  padding: 16px 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
  cursor: pointer;
}

[dir] .card--SZjfy:hover {
  border-color: #999;
}

.cardSelected--NvtDm {
  font-weight: 600;
}

[dir] .cardSelected--NvtDm {
  border-color: #b45309;
  background: rgba(180, 83, 9, 0.05);
}

.cardIcon--UQRrw {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  filter: brightness(0);
}

.cardLabel--Oapyr {
  white-space: nowrap;
}

@media (max-width: 639px) {
  .card--SZjfy {
    flex: 1 1 calc(50% - 8px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/ViewPickerMenu/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EAMR,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAjBA;EAOE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AAMjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAGE,gBAAgB;AAClB;;AAJA;EACE,qBAAqB;EACrB,kCAAkC;AAEpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".viewPickerWrapper {\n  position: absolute;\n}\n\n.cardGrid {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.card {\n  flex: 1 1 0;\n  min-width: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 16px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 400;\n  color: #000;\n  transition: border-color 0.2s ease;\n}\n\n.card:hover {\n  border-color: #999;\n}\n\n.cardSelected {\n  border-color: #b45309;\n  background: rgba(180, 83, 9, 0.05);\n  font-weight: 600;\n}\n\n.cardIcon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  filter: brightness(0);\n}\n\n.cardLabel {\n  white-space: nowrap;\n}\n\n@media (max-width: 639px) {\n  .card {\n    flex: 1 1 calc(50% - 8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewPickerWrapper": `viewPickerWrapper--VJkkH`,
	"cardGrid": `cardGrid--ytFdu`,
	"card": `card--SZjfy`,
	"cardSelected": `cardSelected--NvtDm`,
	"cardIcon": `cardIcon--UQRrw`,
	"cardLabel": `cardLabel--Oapyr`
};
export default ___CSS_LOADER_EXPORT___;
